import React from 'react';
import { useTranslation } from 'react-i18next';
import { WBTabs, WBTab } from '@admiin-com/ds-web';
import { styled } from '@mui/material';

interface TaxTaskTabProps {
  activeTab: number;
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled(WBTabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  marginBottom: theme.spacing(3),
}));

const StyledTab = styled(WBTab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 'medium',
  fontSize: '1rem',
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
}));

const TaxTypeTab: React.FC<TaxTaskTabProps> = ({
  handleTabChange,
  activeTab,
}) => {
  const { t } = useTranslation();

  return (
    <StyledTabs value={activeTab} onChange={handleTabChange} centered>
      <StyledTab label={t('Lodgement', { ns: 'taskbox' })} />
      <StyledTab label={t('Binding', { ns: 'taskbox' })} />
    </StyledTabs>
  );
};

export default TaxTypeTab;
